import * as React from 'react';
import { IgcTooltipComponent as Component } from 'igniteui-webcomponents';
import type { IgcTooltipComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * Provides a way to display supplementary information related to an element when a user interacts with it (e.g., hover, focus).
 * It offers features such as placement customization, delays, sticky mode, and animations.
 * @slot  - Default slot of the tooltip component.
 * @slot close-button - Slot for custom sticky-mode close action (e.g., an icon/button).
 * @fires igcOpening - Emitted before the tooltip begins to open. Can be canceled to prevent opening.
 * @fires igcOpened - Emitted after the tooltip has successfully opened and is visible.
 * @fires igcClosing - Emitted before the tooltip begins to close. Can be canceled to prevent closing.
 * @fires igcClosed - Emitted after the tooltip has been fully removed from view.
 * @csspart base - The wrapping container of the tooltip content.
 * @csspart simple-text - The container where the message property of the tooltip is rendered.
 * @class
 */
export const IgrTooltip = /* @__PURE__ */ createComponent({
  tagName: 'igc-tooltip',
  displayName: 'IgrTooltip',
  elementClass: Component,
  react: React,
  events: {
    onOpening: 'igcOpening' as EventName<
      IgcTooltipComponentEventMap['igcOpening']
    >,
    onOpened: 'igcOpened' as EventName<
      IgcTooltipComponentEventMap['igcOpened']
    >,
    onClosing: 'igcClosing' as EventName<
      IgcTooltipComponentEventMap['igcClosing']
    >,
    onClosed: 'igcClosed' as EventName<
      IgcTooltipComponentEventMap['igcClosed']
    >,
  },
});

export type IgrTooltip = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrTooltipModule = Component;
